import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.mjs';

function buildMetadata(event) {
  if (!event.metadata && !event.consent) {
    return undefined;
  }

  /* eslint-disable @typescript-eslint/naming-convention */
  return _objectSpread2(_objectSpread2({}, event.metadata), event.consent && {
    consent: event.consent,
    consent_provider: event.consent_provider,
    consent_version: event.consent_version
  });
  /* eslint-enable @typescript-eslint/naming-convention */
}

export { buildMetadata };
